import { Component, Input, OnDestroy } from '@angular/core'
import { UiService } from 'src/app/services/ui.service'
import { Application } from '../../../services/application.service'
import { Subscription } from 'rxjs'
import { ApiService } from '../../../../services/api.service'
import { finalize } from 'rxjs/operators'
import { handleArpioError } from '../../../../../utils/handle-error'
import { NewTargetPlanRequiredIssue } from '../../../services/issue'
import { subscriptionActive } from '../../../../../utils/rxjs-utils'
import { SyncPhaseDto } from '../../../../services/dtos'

@Component({
  selector: 'new-target-plan-required-issue',
  templateUrl: 'new-target-plan-required-issue.component.html',
  styleUrls: ['new-target-plan-required-issue.component.scss'],
  standalone: false,
})
export class NewTargetPlanRequiredIssueComponent implements OnDestroy {
  @Input() issue: NewTargetPlanRequiredIssue = null
  @Input('application') application: Application = null

  private restoreSubscription: Subscription = null

  constructor(
    public uiService: UiService,
    public apiService: ApiService
  ) {}

  ngOnDestroy(): void {
    if (subscriptionActive(this.restoreSubscription)) {
      this.restoreSubscription.unsubscribe()
      this.restoreSubscription = null
    }
  }

  public launchRestoreToTryAgain() {
    this.restoreSubscription = this.application
      .initiateRestore$(false, true)
      .pipe(finalize(() => (this.restoreSubscription = null)))
      .subscribe(
        (application) => (this.application = application),
        (error) => {
          handleArpioError(window.location.href, this.apiService, this.uiService)(error)
        }
      )
  }

  public get launchingRestore() {
    return subscriptionActive(this.restoreSubscription)
  }

  public get disableRetry() {
    return (
      this.launchingRestore ||
      (this.application?.currentlyRestoring && this.application?.syncPhase !== SyncPhaseDto.STANDBY)
    )
  }
}
